module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book_list",
    class: {
      bg_height: _vm.isEmpty
    }
  }, [_c('ddHeader', {
    attrs: {
      "title": _vm.titleName
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "book_list_contain",
    class: {
      bg_empty: _vm.isEmpty,
      bg_height: _vm.isEmpty
    }
  }, [_vm._l((_vm.list), function(item) {
    return _c('booklist-item', {
      key: item.id,
      attrs: {
        "conent": item
      }
    })
  }), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoading",
    attrs: {
      "on-infinite": _vm.onInfinite
    }
  }, [_c('div', {
    staticClass: "empty",
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/failure.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.emptyText))])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5110d211"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bookList.vue
// module id = 220
// module chunks = 3